import ModalView from '../components/rover_modal';

Rover.views.QuizView = Backbone.View.extend({
  initialize() {
    _.bindAll(this, 'advanceQuestion', 'displayError', 'onQuestionSuccess', 'onQuestionError');
    const questions = this.getQuestions();
    const currentQuestion = this.getCurrentQuestion();
    const index = questions.index(currentQuestion);
    if (index === 0) {
      this.showIntroModal();
    } else if (index === -1) {
      // Quiz is done, show success view
      this.showQuizDone();
    }
    const self = this;
    $('.js-question-form').ajaxForm({
      beforeSubmit() {
        $('.js-form-error').hide();
      },
      success() {
        return self.onQuestionSuccess(this);
      },
      error(response) {
        return self.onQuestionError(this, response);
      },
    });
  },
  onQuestionSuccess(ajaxForm) {
    this.advanceQuestion();
  },
  onQuestionError(ajaxForm, response) {
    const error = response.responseJSON.error_description;
    this.displayError(error);
  },
  getQuestions() {
    return $('.js-quiz-question');
  },
  getCurrentQuestion() {
    return $(this.getQuestions().filter(':visible'));
  },
  getNextQuestion() {
    const questions = this.getQuestions();
    const index = questions.index(this.getCurrentQuestion());
    const question = questions[index + 1];
    if (question) {
      return $(question);
    }
  },
  advanceQuestion() {
    const nextQuestion = this.getNextQuestion();
    if (nextQuestion) {
      const currentQuestion = this.getCurrentQuestion();
      currentQuestion.hide();
      nextQuestion.show();

      const contentModuleId = nextQuestion.attr('data-content-module-id');
      $('.js-content-module').hide();
      $(`.js-content-module[data-content-module-id="${contentModuleId}"]`).show();
    } else {
      this.showQuizDone();
    }
  },
  displayError(errorText) {
    const currentQuestion = this.getCurrentQuestion();
    currentQuestion.find('input[type=radio]').prop('checked', false);
    const $formErrorDiv = currentQuestion.find('.js-form-error');
    $formErrorDiv.html(errorText);
    $formErrorDiv.show();
  },
  showIntroModal() {
    // for the new SSU we are not going to show the initial modal
    if (Rover.flags.isNewSSU) {
      return;
    }
    const modal = new ModalView({
      title: $('.js-intro-modal-title').html(),
      content: $('.js-intro-modal-content').html(),
    });
    modal.open();
  },
  showQuizDone() {
    $('.js-rover-primary-col').hide();
    $('.js-rover-secondary-col').hide();
    $('.js-quiz-done').show();
  },
});

$(() => {
  const $body = $('body');
  if (!$body.hasClass('js-safety-quiz')) {
    return;
  }
  new Rover.views.QuizView({});
});



// WEBPACK FOOTER //
// ./js/pages/quiz.js